import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, signal, WritableSignal } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoService } from '@ngneat/transloco';
import { FieldType, FormlyModule } from '@ngx-formly/core';
import { FormlyMaterialModule } from '@ngx-formly/material';
import { ButtonType } from 'app/core/dialogBuilder/dialog-builder.models';
import { DialogBuilderService } from 'app/core/dialogBuilder/dialog-builder.service';
import { SelectDataElementDialogComponent } from 'app/modules/data-module/data-management/components/select-data-element-dialog/select-data-element-dialog.component';

@Component({
    selector: 'select-data-elements-form-template',
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        FormlyModule,
        FormlyMaterialModule,
        MatFormFieldModule,
        MatButtonModule,
        MatIconModule,
    ],
    templateUrl: './select-data-elements-form-template.component.html',
    styleUrl: './select-data-elements-form-template.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelectDataElementsFormTemplateComponent extends FieldType {
    private dialog: MatDialogRef<any, any>;
    protected _translocoContent = signal(null);
    private executeActionSignal: WritableSignal<string> = signal(null);

    constructor(
        private dialogService: DialogBuilderService,
        private _translocoService: TranslocoService
    ) {
        super();

        this._translocoService.selectTranslation('bp').subscribe(content => {
            this._translocoContent.set(content);
        });
    }
    openSelectionDialog($event?: any): void {
        $event?.stopPropagation();

        this.dialog = this.dialogService.openDialog({
            descriptor: {
                header: {
                    // title: this._translocoContent()['selectAreaDialogTitle'],
                    title: 'Select table',
                    showCloseButton: true,
                },
                content: {
                    componentConfig: {
                        component: SelectDataElementDialogComponent,
                        componentData: {
                            formControl: this.formControl,
                        },
                    },
                },
                actions: {
                    dialogActions: [
                        {
                            code: 'cancel',
                            style: ButtonType.simple,
                            title: this._translocoContent()['cancel'],
                            dismiss: true,
                        },
                        {
                            code: 'selectDataElement',
                            style: ButtonType.raised,
                            color: 'primary',
                            title: this._translocoContent()['selectArea'],
                            manualClose: true,
                        },
                    ],
                },
                executeActionSignal: this.executeActionSignal,
                dialogSize: 'fullscreen',
            },
        });
    }
}
